module.exports = __webpack_public_path__ + "static/media/logo-avilessur.9e3181c5.jpg";